/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React from 'react';
import PropTypes from 'prop-types';

const PublicRoute = ({
  component: Component,
  layout: Layout,
  ...rest
}) => {
  return (
    <Layout {...rest}>
      <Component />
    </Layout>
  );
};

PublicRoute.propTypes = {
  component: PropTypes.func,
  layout: PropTypes.func.isRequired
};

export default PublicRoute;
